<template>
  <div class="wrapper">
    <input
      class="simple-checkbox"
      :class="checked"
      type="checkbox"
      id="checkboxID"
      :checked="value"
      :disabled="disabled"
    >
    <label
      for="checkboxID"
      @click="onChange($event)"
    />
  </div>
</template>

<script>
export default {
  name: 'm-simple-checkbox',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    checked() {
      return [
        this.value && 'simple-checkbox_checked'
      ]
    }
  },
  methods: {
    onChange(e) {
      e.stopPropagation()
      if (this.disabled) {
        return
      }

      this.$emit('change')
    },
  },
}
</script>

<style lang="scss" scoped>
// https://itchief.ru/html-and-css/styling-checkbox-and-radio
// TODO исправить визуальные эффекты только на одном чекбоксе в SECTIONS
.wrapper {
  display: flex;
  position: relative;
  padding: 0 0 0 5px;
}
.simple-checkbox {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  visibility: hidden;
  // z-index: -1;
  // pseudo element
  &+label {
    display: inline-flex;
    align-items: center;
    user-select: none;

    &::before {
      content: '';
      display: inline-block;
      width: 1em;
      height: 1em;
      flex-shrink: 0;
      flex-grow: 0;
      padding: 1px;
      border: 1px solid $primary-old;
      border-radius: 0.25em;
      margin-right: 0.5em;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 50% 50%;
      transition: all .25s;
    }
  }
  // checked
  &_checked+label::before {
    border-color: $primary-old;
    background-color: $primary-old;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e");
  }
  // hover
  &:not(:disabled):not(:checked)+label:hover::before {
    border-color: $light-primary-old;
  }
  // focus
  &:focus+label::before {
    box-shadow: 0 0 0 0.2rem $light-primary-old;
  }
  // disabled
  &:disabled+label::before {
    background-color: $light-gray-old;
    border-color: $secondary-text-old;
  }
}
</style>